import { db } from "@/api/firebase";
import { City } from "@/models/City";
import { GameError } from "@/models/Errors/GameError";
import { ManhuntMapPoi } from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { forIn, isEmpty } from "lodash";
import Errors from "./Errors";
export default class ErrorsGame {
  mapPoi: ManhuntMapPoi[];
  gameUid: string;
  cityData: City;
  errorObject = {} as GameError;
  constructor(gameUid: string, mapPoi: ManhuntMapPoi[], cityData: City) {
    this.mapPoi = mapPoi;
    this.gameUid = gameUid;
    this.cityData = cityData;
  }

  checkGameErrors(): GameError {
    this.checkAllMapPoiErrors();
    this.countErrorIssues();
    this.countLocationTwice();
    this.checkCityHasTimeZone();
    this.checkMultipleGuilty();
    this.checkMultipleTutorials();
    this.checkNoGuilty();
    if (!isEmpty(this.errorObject)) {
      db.ref("games/" + this.gameUid + "/issues/err/").set(this.errorObject);
    } else {
      db.ref("games/" + this.gameUid + "/issues/err/").remove();
    }
    return this.errorObject;
  }

  private countErrorIssues(): void {
    let count = 0;
    this.mapPoi.forEach((x: ManhuntMapPoi) => {
      if (x.issues?.err !== undefined) {
        count++;
      }
    });
    if (count > 0) {
      this.errorObject.error_count = {
        active: true,
        txt: { en: "POI Error: " + count + " POIs with Errors" },
        count: count,
      };
    } else {
      if (this.errorObject.error_count !== undefined) {
        delete this.errorObject.error_count;
      }
    }
  }


  private countLocationTwice(): void {
    const locations: string[] = [];
    this.mapPoi.forEach((x: ManhuntMapPoi) => {
      locations.push(x.loc.loc_uid);
    });
  }

  private checkMultipleTutorials(): void {
    if (this.mapPoi.filter((x: ManhuntMapPoi) => x.tutorial).length > 1) {
      this.errorObject.multiple_tutorials = {
        active: true,
        txt: {
          en: "More than 1 POI has been set as the Tutorial",
        },
      };
    }
  }

  private checkMultipleGuilty(): void {
    if (
      this.mapPoi.filter(
        (x: ManhuntMapPoi) => x.witness !== undefined && x.witness.guilt
      ).length > 1
    ) {
      this.errorObject.multiple_guilt = {
        active: true,
        txt: {
          en: "More than 1 POI has been set as the Guilty party",
        },
      };
    }
  }
  private checkNoGuilty(): void {
    if (
      this.mapPoi.filter(
        (x: ManhuntMapPoi) => x.witness !== undefined && x.witness.guilt
      ).length == 0
    ) {
      this.errorObject.no_guilt = {
        active: true,
        txt: {
          en:
            "Nobody has been set as the Guilty party. 1 POI must be marked as guilty",
        },
      };
    }
  }
  private checkCityHasTimeZone(): void {
    if (
      this.cityData.tZone === undefined ||
      this.cityData.tZone.timeZoneId.length == 0 ||
      this.cityData.tZone.timeZoneName.length == 0
    ) {
      this.errorObject.timezone_not_exist = {
        active: true,
        txt: {
          en:
            "The selected city is missing timezone information. Edit the city centre_point to fix this.",
        },
      };
    } else {
      if (this.errorObject.timezone_not_exist !== undefined) {
        delete this.errorObject.timezone_not_exist;
      }
    }
  }

  private checkAllMapPoiErrors(): void {
    this.mapPoi.forEach((x: ManhuntMapPoi) => {
      const errorObject = new Errors(x, this.gameUid).checkMapPoiErrors();
      if (!isEmpty(errorObject)) {
        x.issues = { err: errorObject };
      }
    });
  }
}
